/*eslint-disable*/
import { default as React } from 'react';
import en from '../i18n/en';
import es from '../i18n/es';

const languages = {
  en,
  es
};
const debug = _debug('app:Translate');
export default function translate(key) {
  debug(key);
  return (Component) => {
    class TranslationComponent extends React.Component {
      render() {
        if (typeof (key) === 'object') { //eslint-disable-line
          const strings = key.map(value => languages[this.context.currentLanguage][value]);
          return <Component {...this.props} {...this.state} strings={strings} />;
        }
        const strings = languages[this.context.currentLanguage][key];
        return (
          <Component
            {...this.props}
            {...this.state}
            strings={strings}
            language={this.context.currentLanguage}
          />
        );
      }
    }

    TranslationComponent.contextTypes = {
      currentLanguage: React.PropTypes.oneOfType([
        React.PropTypes.string,
        React.PropTypes.shape([]),
      ])
    };

    return TranslationComponent;
  };
}



// WEBPACK FOOTER //
// ./src/i18n/translate.js